type Props = {
  title: string;
  disabled?: boolean;
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type'];
  onClick?: (e: React.MouseEvent) => void;
  className?: string[];
};

export default function StickyButton({ title, type, onClick, disabled, className }: Props): JSX.Element {
  return (
    <div className={['flex', 'flex-col', 'w-full', ...(className || [])].join(' ')}>
      <button
        disabled={disabled}
        type={type ? type : 'button'}
        onClick={(e) => onClick && onClick(e)}
        className={[
          ['border', 'border-bluey-purple', 'text-white', 'N_16_M', 'bg-bluey-purple', 'focus:bg-active-bluey-purple'].join(' '),
          disabled && 'bg-light-grey-blue border-light-grey-blue text-opacity-50 text-white',
          'py-5.5',
        ].join(' ')}
      >
        {title}
      </button>
    </div>
  );
}
